import React from 'react'

export const Loader: React.FC<{ size?: string }> = ({ size = 'h-10 w-10' }) => (
  <div className={`animate-spin rounded-full border-4 border-primary-500 border-t-transparent ${size}`} />
)

export const EmptyState: React.FC<{ title: string; description?: string }> = ({ title, description }) => (
  <div className="text-center py-14">
    <div className="text-5xl mb-4">🕊️</div>
    <h3 className="text-lg font-bold text-gray-800 mb-1">{title}</h3>
    {description && <p className="text-sm text-gray-500">{description}</p>}
  </div>
)

interface PaginationProps {
  page: number
  totalPages: number
  onChange: (page: number) => void
}

export const Pagination: React.FC<PaginationProps> = ({ page, totalPages, onChange }) => {
  if (totalPages <= 1) return null

  const pages: number[] = []
  const start = Math.max(1, page - 2)
  const end = Math.min(totalPages, page + 2)
  for (let i = start; i <= end; i++) pages.push(i)

  return (
    <div className="flex items-center justify-center gap-2 mt-8">
      <button
        className="btn btn-secondary !px-3 disabled:opacity-40"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
      >
        قبلی
      </button>
      {start > 1 && <span className="text-gray-400">…</span>}
      {pages.map((p) => (
        <button
          key={p}
          onClick={() => onChange(p)}
          className={`btn !px-3.5 ${p === page ? 'btn-primary' : 'btn-secondary'}`}
        >
          {p.toLocaleString('fa-IR')}
        </button>
      ))}
      {end < totalPages && <span className="text-gray-400">…</span>}
      <button
        className="btn btn-secondary !px-3 disabled:opacity-40"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
      >
        بعدی
      </button>
    </div>
  )
}